import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { Loader } from '../../../components/Loader';
import { selectPermissions, selectWorks } from '../../Api/selectors';
import { createBoard, deleteBoard, fetchKanbanBoards } from '../actions';
import { REQUEST_KANBAN_BOARDS } from '../constants';
import { selectKanbanBoards } from '../selectors';
import { HBox } from '../../../components/Box';
import { ChevronRight, Plus, Trash, Edit } from '../../../components/Icon';
import { PageHeader } from '../../../components/PageHeader';
import { Permission } from '../../../components/Permission';
import { KANBAN_BOARD_CREATE, KANBAN_BOARD_EDIT, KANBAN_BOARD_REMOVE } from '../../../components/Permission/constants';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

import styles from './Overview.module.css';
import { KanbanPermissions } from '../components/KanbanPermissions';

const Container = styled.div``;

const STATE = {
  addBoard: null,
  addBoardValue: '',
  deleteBoardConfirm: null,
};

/* eslint-disable react/prefer-stateless-function */
class KanbanBoardsOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetch();
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;

    return (
      <Container>
        <div className="container-fluid p-0">
          <PageHeader
            title={this.lbl('kanban.overview.title')}
            breadCrumbs={
              <>
                <a href="/">Vindat</a>
                <ChevronRight />
                {this.lbl('kanban.overview.title')}
              </>
            }
          />

          {this.renderAddBoard()}
          {this.renderDeleteBoard()}

          <Permission permission={KANBAN_BOARD_CREATE}>
            <ButtonComponent onClick={this.setStateFn({ addBoard: true })} style={'ButtonSoftPrimary'}>
              <Plus />
            </ButtonComponent>
          </Permission>

          <table className="table table-hover table-centered mb-0 mt-3">
            <tbody>
              {this.props.boards?.map((board, index) => (
                <KanbanPermissions boardName={board?.label}>
                  <tr key={index}>
                    <td
                      role="button"
                      onClick={this.tofn(`/boards/${board.id}`)}
                      className="table-id text-center align-middle"
                    >
                      <div className={styles.IdText}>{board.id}</div>
                    </td>
                    <td
                      role="button"
                      onClick={this.tofn(`/boards/${board.id}`)}
                      className={`table-id align-middle ${styles.LabelText}`}
                    >
                      {board.label}
                    </td>
                    <td className="table-action">
                      <div className="d-flex gap-2 justify-content-end">
                        <Permission permission={KANBAN_BOARD_EDIT}>
                          <ButtonComponent onClick={this.tofn(`/boards/${board.id}/edit`)} style={'ButtonSoftEdit'}>
                            <Edit />
                          </ButtonComponent>
                        </Permission>
                        <Permission permission={KANBAN_BOARD_REMOVE}>
                          <ButtonComponent
                            onClick={this.setStateFn({ deleteBoardConfirm: board.id })}
                            style={'ButtonSoftDelete'}
                          >
                            <Trash />
                          </ButtonComponent>
                        </Permission>
                      </div>
                    </td>
                  </tr>
                </KanbanPermissions>
              ))}
            </tbody>
          </table>

          <HBox onClick={this.tofn(`/boards/tmp1`)}>Klantoverzicht 1</HBox>
        </div>

        <Permission permission={KANBAN_BOARD_EDIT}>
          <div className="btn-group justify-content-center align-items-center">
            <ButtonComponent onClick={this.tofn('/boards/test')} style={'ButtonSoftPrimary'}>
              Test
            </ButtonComponent>
            <ButtonComponent onClick={this.tofn('/boards/cache-status')} style={'ButtonSoftPrimary'}>
              Cache-status
            </ButtonComponent>
          </div>
        </Permission>
      </Container>
    );
  }

  renderAddBoard() {
    if (!this.state.addBoard) return null;
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('kanban.modal.add.title')}>
        <>
          <form>
            <div class="mb-3">
              <label for="name-board" className="form-label fw-normal">
                {this.lbl('kanban.modal.board.name')}
              </label>
              <input
                name="addBoardValue"
                value={this.state.addBoardValue}
                onChange={this.onInputChange.bind(this)}
                type="text"
                className="form-control fw-lighter"
                id="name-board"
                placeholder="Add name board"
              />
            </div>
            <div className="d-flex gap-2 justify-content-end">
              <button onClick={this.reset.bind(this)} type="button" className={`btn ${styles.ButtonSoftLight}`}>
                {this.lbl('cancel')}
              </button>
              <button
                onClick={() => {
                  this.props.createBoard(this.state.addBoardValue, this.reset.bind(this));
                }}
                type="submit"
                className={`btn ${styles.ButtonSoftEdit}`}
              >
                {this.lbl('confirm')}
              </button>
            </div>
          </form>
        </>
      </ModalComponent>
    );
  }

  renderDeleteBoard() {
    if (!this.state.deleteBoardConfirm) return null;
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('kanban.modal.delete.confirm.title')}>
        <div className="d-flex gap-2 justify-content-end">
          <button onClick={this.reset.bind(this)} type="button" className={`btn ${styles.ButtonSoftLight}`}>
            {this.lbl('cancel')}
          </button>
          <button
            onClick={() => {
              this.props.deleteBoard(this.state.deleteBoardConfirm, this.reset.bind(this));
            }}
            type="button"
            className={`btn ${styles.ButtonSoftDelete}`}
          >
            {this.lbl('confirm')}
          </button>
        </div>
      </ModalComponent>
    );
  }
}

KanbanBoardsOverviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    boards: selectKanbanBoards(),
    work: selectWorks([REQUEST_KANBAN_BOARDS]),
    permissions: selectPermissions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(fetchKanbanBoards());
    },
    createBoard(name, callback) {
      dispatch(createBoard(name, callback));
    },
    deleteBoard(boardId, callback) {
      dispatch(deleteBoard(boardId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanBoardsOverview = compose(withConnect, withRouter)(KanbanBoardsOverviewComp);
